
import { useNavigate } from "react-router-dom";
import { useSafetyAlarm } from "./SafetyAlarmProvider";
import { useTranslation } from "react-i18next";

const EmergencyBanner = () => {


    const [t] = useTranslation(["safety"])

    const { isEmergency } = useSafetyAlarm();
    const navigate = useNavigate();

    if (!isEmergency) return null;

    return (
        <div
            className="alert alert-danger text-center text-white fixed-top mb-0 rounded-0 emergency-banner"
            role="alert"
            style={{ zIndex: 9999, cursor: "pointer" }}
            onClick={() => navigate("/dashboard/safety/dashboard")}
        >
            <h3>🚨 {t("helper.emergency_title")}</h3>
            {t("helper.emergency_banner")}
        </div>
    );
};

export default EmergencyBanner;
